import React, { useEffect, useState } from 'react';
import {
  batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';
import PropTypes from 'prop-types';

import Text from '../../../components/Text/Text';
import CustomSelect from '../../../components/Select/CustomSelect';
import getCarMakeList from '../../../thunks/general/getCarMakeList';
import getCarModelList from '../../../thunks/general/getCarModelList';
import Button from '../../../components/Button/Button';
import { IconPlus } from '../../../assets/icon';
import ButtonTypes from '../../../constants/buttonTypes';
import getCarYearList from '../../../thunks/general/getCarYearList';

const dividerClassName = 'm-[10px]';

const CarSelector = ({ onSelect }) => {
  const dispatch = useDispatch();
  const [carMake, setCarMake] = useState();
  const [carModel, setCarModel] = useState();
  const [carYears, setCarYears] = useState();
  const {
    carMakeList, carMakeListLoading,
    carModelList, carModelListLoading,
    carYearList, carYearLoading
  } = useSelector((state) => ({
    carMakeList: state?.getCarMakeList?.list,
    carMakeListLoading: state?.getCarMakeList?.loading,
    carModelList: state?.getCarModelList?.list,
    carModelListLoading: state?.getCarModelList?.loading,
    carYearList: state?.getCarYearList?.list,
    carYearLoading: state?.getCarYearList?.loading,
  }), shallowEqual);

  useEffect(() => {
    if (!carMakeList.length && !carMakeListLoading) {
      dispatch(getCarMakeList());
    }
  }, []);

  useEffect(() => {
    if (carMake?.value) {
      dispatch(getCarModelList({ make: carMake?.value }));
    }
  }, [carMake]);

  useEffect(() => {
    if (carModel?.value) {
      dispatch(getCarYearList({ make: carMake?.value, model: carModel?.value }));
    }
  }, [carModel]);

  const onAdd = () => {
    batch(() => {
      setCarMake(null);
      setCarModel(null);
      setCarYears(null);
    });
    onSelect({
      make: carMake?.value,
      model: carModel?.value,
      year: carYears?.map((i) => i.value)
    });
  };

  return (
    <>
      <div className="flex flex-row justify-between">
        <div className="flex-1">
          <Text text="Car make:" muted />
          <CustomSelect
            options={carMakeList}
            isSearchable
            placeholder={carMakeListLoading ? 'Loading...' : 'Select make'}
            onChange={(data) => {
              setCarMake(data);
              setCarModel(null);
              setCarYears(null);
            }}
            value={[carMake]}
            isDisabled={carMakeListLoading}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex-1">
          <Text text="Car model:" muted />
          <CustomSelect
            options={carModelList}
            isSearchable
            placeholder={carModelListLoading ? 'Loading...' : 'Select model'}
            onChange={(data) => {
              setCarModel(data);
              setCarYears(null);
            }}
            value={[carModel]}
            isDisabled={!carMake}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex-1">
          <Text text="Car year:" muted />
          <CustomSelect
            options={carYearList}
            isSearchable
            placeholder={carYearLoading ? 'Loading...' : 'Select year'}
            onChange={setCarYears}
            value={carYears}
            isDisabled={!carModel}
            isMulti
            closeMenuOnSelect={false}
            maxSelectedValue={99}
          />
        </div>
      </div>
      <br />
      <Button
        icon={<IconPlus />}
        type={ButtonTypes.LIGHT_PRIMARY}
        onClick={onAdd}
        disabled={!carYears?.length}
      />
    </>
  );
};

CarSelector.propTypes = {
  onSelect: PropTypes.func
};

CarSelector.defaultProps = {
  onSelect: () => {}
};

export default CarSelector;
